<template>
    <article class="content-wrap">

        <h1>TERMS AND CONDITIONS OF USE</h1>
        <p><strong>THE FOLLOWING TERMS AND CONDITIONS OF USE AGREEMENT (hereafter “Terms”) governs your use of our web site (hereafter “web site”). It is vitally important that you read the Terms carefully, as your use of the web site will automatically constitute your agreement to be legally bound by the terms and conditions set out herein. These Terms also govern your use or purchase of the products/services provided through or in connection with the web site (hereafter “services”). Each time you use our services, you acknowledge that you have read these Terms and agree to be legally bound by them. If you do not agree to be bound by these Terms, you may not use the web site(s) or the services provided by Business through its web site(s).</strong></p>
        <p>The following words used in these Terms shall have the following meanings:</p>
        <ul>
            <li><strong> “Personal Information”</strong> shall mean all data and/or information provided by and about User, including e-mail address (es), name, address, credit card, or other payment information, etc.;</li>
            <li><strong>“Business web site”</strong> shall mean all web sites on which <strong>Business</strong> provides products and/or services.</li>
            <li><strong>“Business User”</strong> shall mean all Users of the Business web site(s) and services.</li>
            <li><strong>“Business Products and Services”</strong> shall mean all products and/or services provided directly by Business;</li>
            <li><strong>“3rd–Parties”</strong> include all advertisers, partners and affiliate vendors that are included on, or linked to, the Business web site(s).</li>
        </ul>








        <h2>LICENCE AND COPYRIGHT</h2>
        <p>The Business web site contains copyrighted material, trademarks and other proprietary information, including, but not limited to, text, software, photos, video, graphics, music and sound and the entire content of the web site is copyrighted as a collective work under UK and International copyright laws. The Business owns a copyright in the selection, coordination, arrangement and enhancement of such content, as well as in the content original to it. You may not modify, publish, transmit, participate in the transfer or sale, create derivative works or in any way exploit, any of the content, in whole or in part. Except as otherwise expressly permitted under copyright law or these Terms, no copying, redistribution, retransmission, publication or commercial or non-commercial exploitation of downloaded material will be permitted without the express written permission of Business and the copyright owner. Elements of the web site are protected by trade dress, trademark, unfair competition and other laws and may not be copied or imitated in whole or in part, by any means, including but not limited to, the use of framing or mirrors.</p>
        <p>You are permitted to print and download extracts from this website for your own private use on the following basis:<br>
            (a) no documents or related graphics on this website are modified in any way;<br>
            (b) no graphics on this website are used separately from accompanying text; and<br>
            (c)any of our copyright and trade mark notices and this permission notice appear in all copies.</p>


        <h3>Copyright Infringement – Digital Millennium Copyright Act</h3>
        <p>If operating in America: The Digital Millennium Copyright Act of 1998 (the “DMCA”) provides recourse for copyright owners who believe that material appearing on the Internet infringes their rights under U.S. copyright law. If you are a copyright owner or an agent thereof and believe in good faith that materials hosted by Business infringe your copyright, you (or your agent) may send Business a notice requesting that the material be removed or access to it blocked by providing Business’s Copyright Agent with the following information in writing (see 17 U.S.C 512(c)(3) for further detail):</p>
        <p>1. A physical or electronic signature of a person authorized to act on behalf of the owner of an exclusive right that is allegedly infringed;<br>
            2. Identification of the copyrighted work claimed to have been infringed, or, if multiple copyrighted works at a single online web site are covered by a single notification, a representative list of such works at that website;<br>
            3. Identification of the material that is claimed to be infringing or to be the subject of infringing activity, and that is to be removed or access to which is to be disabled and information reasonably sufficient to permit the Business to locate the material;<br>
            4. Information reasonably sufficient to permit the Business to contact you, such as a name, address, telephone number, and, if available, an e-mail address;<br>
            5. A statement that you have a good faith belief that use of the material in the manner complained of is not authorized by the copyright owner, its agent, or the law; and<br>
            6. A statement that the information in the notification is accurate, and under penalty of perjury, that you are authorized to act on behalf of the owner of an exclusive right that is allegedly infringed.</p>
























































































    </article>
</template>

<script>
    export default {
        name: 'termsConditions',
        metaInfo() {
            let title = "All Cricket Matches, Score, Update, Schedule, Upcoming";
            let description = "Get all the latest cricket news, live scores, results, match schedules, articles, player & team updates, and cricket videos - PlanetCricket";
            return {
                title: title,
                meta: this.$getMetaTags(title, description),
                link:[
                        {rel: 'canonical', href: 'https://planetcricket.com'+this.$route.path}],
            }
        },
        created() {
//            console.log(isBrowser+"test");
        },
    }
</script>
